import React from 'react'

interface IDividerProps extends React.HTMLAttributes<HTMLDivElement> {
  spacing?: 'small' | 'medium' | 'large' | 'none'
}

const Divider: React.FC<IDividerProps> = ({ spacing = 'none', ...rest }) => (
  <hr className={`divider divider-${spacing}`} {...rest} />
)

export default Divider
